module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 20,
      "md": 16
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.title')) + " #" + _vm._s(_vm.currentOrder.number) + " - " + _vm._s(_vm.$t('static.orders.types.' + _vm.orderType)))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 4,
      "md": 8
    }
  }, [_c('div', {
    staticClass: "flex",
    staticStyle: {
      "justify-content": "flex-end",
      "margin-bottom": "1em"
    }
  }, [_c('div', [_c('i', {
    staticClass: "el-icon-back",
    class: {
      'disabled': !this.previousOrderId
    },
    staticStyle: {
      "margin-right": "10px",
      "font-size": "1.8rem",
      "font-weight": "bold",
      "cursor": "pointer",
      "color": "#fff"
    },
    on: {
      "click": _vm.previousOrder
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-back",
    class: {
      'disabled': !this.nextOrderId
    },
    staticStyle: {
      "font-size": "1.8rem",
      "font-weight": "bold",
      "cursor": "pointer",
      "color": "#fff",
      "transform": "rotate(180deg)"
    },
    on: {
      "click": _vm.nextOrder
    }
  })])])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "background": "transparent"
    }
  }, [_c('br'), _c('br')]) : _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.orders.formTabs.orderInformation'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "lg": 16
    }
  }, [(_vm.is220 && true == _vm.currentOrder.isVinmonopolet) ? _c('el-alert', {
    attrs: {
      "title": "Type 220 - Normal bestilling",
      "description": "Normal levering til Vinmonopolet etter inngåtte avtaler",
      "type": "info",
      "center": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isZNB && true == _vm.currentOrder.isVinmonopolet) ? _c('el-alert', {
    attrs: {
      "title": "Type ZNB - Levert ikke bestilt vare",
      "description": "Opprettes dersom Vinmonopolet mottek ein vare som ikkje er bestilt. Det opprettes ein ny ordre som sendes som bestilling til leverandør. Denne inneheld nytt ordrenummer og referanse til ordrenummeret som varen vart levert sammen med. Viktig at varen IKKE sendes på nytt! Vinmonopolet skal ha ein faktura med referanse til det nye ordrenummeret",
      "type": "info",
      "center": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isZRE && true == _vm.currentOrder.isVinmonopolet) ? _c('el-alert', {
    attrs: {
      "title": "Type ZRE - Retur",
      "description": "Opprettes dersom Vinmonopolet skal returnera ein eller fleire varer. Viktig at varen IKKE sendes på nytt! Vinmonopolet skal ha ein kreditnota med referanse til returordren",
      "type": "info",
      "center": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isZKA && true == _vm.currentOrder.isVinmonopolet) ? _c('el-alert', {
    attrs: {
      "title": "Type ZKA - Kassasjon",
      "description": "Opprettes dersom det er avtale om kassering av varer (destruering, taes bort fra salg pga utløpsdato osv.). Viktig at varen IKKE sendes på nytt! Vinmonopolet skal ha ein kreditnota med referanse til kassasjonsordren",
      "type": "info",
      "center": "",
      "closable": false
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v(_vm._s(_vm.$t('static.orders.edit.detailsLegend')))]), _vm._v(" "), _c('el-row', {
    staticClass: "margin-b-10"
  }, [_c('el-col', {
    attrs: {
      "md": 14
    }
  }, [(_vm.currentOrder.orderType === 'EDI') ? [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.storeName')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentEdiOrder.ediStoreName) + " ( #" + _vm._s(_vm.currentEdiOrder.ediStorePartyId) + " )\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10",
    on: {
      "click": _vm.scrollWindow
    }
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.storeAddress')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                        " + _vm._s(((_vm.currentEdiOrder.ediStoreStreet) + " " + (_vm.currentEdiOrder.ediStorePostCode))) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.requestedDeliveryDate')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentEdiOrder.requestedDeliveryDate) + "\n                      ")])]), _vm._v(" "), (_vm.currentOrder.shippingProvider && _vm.currentOrder.shippingProvider !== 0) ? _c('div', [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-truck",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingProvider')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.currentEdiOrder.shippingProvider) + "\n                        ")])]), _vm._v(" "), (_vm.currentOrder.pickup) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-archive",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickup')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.pickupStatus) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.pickupBy) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickupBy')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.pickupBy) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.pickupDate) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickupDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.formatDate(_vm.currentOrder.pickupDate)) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.deliveryDate) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.deliveryDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.formatDate(_vm.currentOrder.deliveryDate)) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.shippingDate) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.formatDate(_vm.currentOrder.shippingDate)) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.note) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.note')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.note) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderPickupId) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingOrder')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'orderPickups.index',
        params: {
          number: _vm.currentOrder.number
        }
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('static.orders.edit.shippingOrderText')) + "\n                          ")])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderTrackingNumber) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.trackingNumber')) + ":\n                      ")]), _vm._v(" "), (_vm.currentOrder.trackingUrl != '#') ? _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_c('a', {
    attrs: {
      "href": _vm.currentOrder.trackingUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.currentOrder.orderTrackingNumber))])]) : _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentOrder.orderTrackingNumber + ' - ' + _vm.$t('static.orders.edit.trackingUrlNotAvail')) + "\n                      ")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderType !== 'EDI') ? [(_vm.currentClient.companyName) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-building",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.company')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentClient.companyName) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.currentClient.firstName || _vm.currentClient.lastName) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.name')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentClient.firstName + ' ' + _vm.currentClient.lastName) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderType !== 'Appointment') ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-address-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.address')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                        " + _vm._s(((_vm.currentClient.streetName) + " " + (_vm.currentClient.postalCode))) + "\n                      ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.shippingProvider && _vm.currentOrder.shippingProvider !== 0) ? _c('div', [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-truck",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingProvider')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.shippingProvider) + "\n                        ")])]), _vm._v(" "), (_vm.currentOrder.pickup) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-archive",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickup')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.pickup) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.pickupBy) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-user",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickupBy')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.pickupBy) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.pickupDate) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.pickupDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.pickupDate) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.deliveryDate) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.deliveryDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.deliveryDate) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.shippingDate) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingDate')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.shippingDate) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.note) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.note')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.note) + "\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderPickupId) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.shippingOrder')) + ":\n                        ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'orderPickups.index',
        params: {
          number: _vm.currentOrder.number
        }
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('static.orders.edit.shippingOrderText')) + "\n                          ")])], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderTrackingNumber) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.trackingNumber')) + ":\n                      ")]), _vm._v(" "), (_vm.currentOrder.trackingUrl != '#') ? _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_c('a', {
    attrs: {
      "href": _vm.currentOrder.trackingUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.currentOrder.orderTrackingNumber))])]) : _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentOrder.orderTrackingNumber + ' - ' + _vm.$t('static.orders.edit.trackingUrlNotAvail')) + "\n                      ")])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderType === 'Appointment') ? [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.appointmentDate')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status",
    class: _vm.currentOrder.orderStatus
  }, [_vm._v("\n                        " + _vm._s(_vm.formatDate(_vm.currentOrder.booking.date)) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.appointmentTime')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status",
    class: _vm.currentOrder.orderStatus
  }, [_vm._v("\n                        " + _vm._s(_vm.currentOrder.booking.startTime) + " - " + _vm._s(_vm.currentOrder.booking.endTime) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.appointmentDuration')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status",
    class: _vm.currentOrder.orderStatus
  }, [_vm._v("\n                        " + _vm._s(_vm.currentOrder.booking.durations) + " " + _vm._s(_vm.$t('static.orders.edit.minutes')) + "\n                      ")])])] : _vm._e(), _vm._v(" "), (_vm.currentOrder.internalNote) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.internalNote')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.internalNote) + "\n                    ")])]) : _vm._e()], 2), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10
    }
  }, [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.orderNumber')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.number) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.orderType')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.orderType === 'EDI' ? _vm.$t('static.orders.types.' + _vm.orderType) + ' (' + _vm.currentEdiOrder.ediOrderTypeName + ')' : _vm.$t('static.orders.types.' + _vm.orderType)) + "\n                    ")])]), _vm._v(" "), (_vm.currentOrder.orderType === 'EDI') ? [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.ediNumber')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                        " + _vm._s(_vm.currentEdiOrder.orderNumber) + "\n                      ")])]), _vm._v(" "), (_vm.currentEdiOrder.ediOrderSourceOrderNumber) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.linkedEdiNumber')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'orders.edit',
        params: {
          id: _vm.currentEdiOrder.ediOrderSourceOrderId
        }
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.currentEdiOrder.ediOrderSourceOrderNumber) + "\n                        ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.zreOrderSourceOrderNumber) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.linkedEdiNumber')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'orders.edit',
        params: {
          id: _vm.currentOrder.zreOrderSource
        }
      }
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.currentOrder.zreOrderSourceOrderNumber) + "\n                        ")])], 1)]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-calendar",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.orderDate')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.orderType === 'EDI' ? _vm.currentEdiOrder.createdAt : _vm.formatDate(_vm.currentOrder.createdAt)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.orderStatus')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status",
    class: _vm.currentOrder.orderStatus
  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.orderType === 'EDI' ?
    _vm.$t(("static.ediOrders.index." + (_vm.currentOrder.sent && _vm.currentOrder.orderStatus !== 'cancelled' ? 'bill_sent' : _vm.currentEdiOrder.ediOrderStatusName))) :
    _vm.$t(("static.orders.status." + (_vm.currentOrder.sent && _vm.currentOrder.orderStatus !== 'cancelled' ? 'bill_sent' : _vm.currentOrder.orderStatus)))) + "\n                    ")])]), _vm._v(" "), (_vm.currentClient.orderReference) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.orderReference')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                      " + _vm._s(_vm.currentClient.orderReference) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.referenceNumber) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.referenceNumber')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status"
  }, [_vm._v("\n                      " + _vm._s(_vm.currentOrder.referenceNumber) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.checkHasInventory == true) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.warehouse')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small _status",
    class: _vm.currentOrder.orderStatus
  }, [_vm._v("\n                      " + _vm._s(_vm.currentWarehouse) + "\n                      "), (_vm.warehouseOption) ? _c('button', {
    staticClass: "el-button el-button--default small",
    attrs: {
      "type": "button",
      "round": ""
    },
    on: {
      "click": _vm.activateWarehouseModal
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.bills.length) ? _c('div', [_c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-id-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.bill')) + ":\n                      ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._l((_vm.bills), function(b, i) {
    return [_c('router-link', {
      attrs: {
        "to": {
          name: 'bills.edit',
          params: {
            id: b.id
          }
        }
      }
    }, [_vm._v("\n                            " + _vm._s(b.billingNumber ? ("#" + (b.billingNumber)) : _vm.$t('static.reports.bills.draft')) + "\n                          ")]), _vm._v(" "), (i < _vm.bills.length - 1) ? _c('span', [_vm._v(" | ")]) : _vm._e()]
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.creditNotes.length) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-id-card-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.orders.edit.creditNotes')) + ":\n                    ")]), _vm._v(" "), _c('span', {
    staticClass: "label-content label-content--small"
  }, [_vm._l((_vm.creditNotes), function(c, i) {
    return [_c('router-link', {
      attrs: {
        "to": {
          name: 'bills.creditNote',
          params: {
            id: c.id
          }
        }
      }
    }, [_vm._v("\n                          " + _vm._s(c.billingNumber ? ("#" + (c.billingNumber)) : ((_vm.$t('static.reports.bills.draft')) + " " + (i + 1))) + "\n                        ")]), _vm._v(" "), (i < _vm.creditNotes.length - 1) ? _c('span', [_vm._v(" | ")]) : _vm._e()]
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.currentOrder.details) ? _c('div', {
    staticClass: "margin-b-10"
  }, [_c('label', {
    staticClass: "label label--small"
  }, [_c('i', {
    staticClass: "fa fa-sticky-note-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   " + _vm._s(_vm.currentOrder.details) + "\n                    ")])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('el-row', [(_vm.currentOrder.orderType == 'Return' && _vm.currentOrder.orderStatus != 'completed') ? _c('el-col', {
    attrs: {
      "md": 24
    }
  }, [_c('div', {
    staticClass: "el-alert--info full-w padding-a-15"
  }, [_c('el-button', {
    staticClass: "small margin-b-10",
    on: {
      "click": _vm.completeReturnOrder
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('button.complete')) + "\n                    ")])], 1)]) : (_vm.currentOrder.orderType == 'Return' && _vm.currentOrder.orderStatus == 'completed') ? _c('el-col', {
    attrs: {
      "md": 24
    }
  }, [_c('div', {
    staticClass: "el-alert--info full-w padding-a-15"
  }, [_vm._v(_vm._s(_vm.$t('static.orders.edit.returnOrderComplete')))]), _vm._v(" "), ((_vm.isZNB || _vm.is220) && (_vm.isEdiConfirmed || _vm.isEdiProcessed || _vm.isAskoAndBilled) || (_vm.currentOrder.orderType != 'EDI')) ? _c('div', {
    staticClass: "small btn-group margin-b-10 margin-t-10 ma  margin-r-10"
  }, [_c('button', {
    staticClass: "btn info el-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showPrintableDeliveryNote
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('button.showPrintableDeliveryNote')))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.toggleDropdownDelivery
    }
  }, [_c('span', {
    staticClass: "sr-only"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    class: {
      show: _vm.dropdownStateDelivery
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.showPrintableDeliveryNote
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                         " + _vm._s(_vm.$t('button.showPrintableDeliveryNote')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.downloadPrintableDeliveryNote
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                         " + _vm._s(_vm.$t('button.downloadPrintableDeliveryNote')))])])], 1) : _vm._e()]) : _c('el-col', {
    attrs: {
      "md": 24
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24
    }
  }, [_c('div', {
    staticClass: "el-alert--info full-w padding-a-15"
  }, [_c('div', {
    staticClass: "full-w flex margin-b-10"
  }, [(_vm.hasUnconfirmedOrderProduct && _vm.is220) ? _c('span', {
    staticClass: "margin-b-10"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('static.orders.edit.pleaseConfirmAllOrderProducts')) + "\n                          ")]) : _vm._e()]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 4
    }
  }, [(_vm.canCreateCreditNote) ? _c('el-button', {
    staticClass: "small",
    on: {
      "click": _vm.createCreditNote
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('button.createCreditNote')) + "\n                            ")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8
    }
  }, [((_vm.currentOrder.orderType !== 'EDI') && _vm.canCancelOrder) ? _c('el-button', {
    staticClass: "small danger margin-b-10",
    attrs: {
      "icon": "el-icon-close",
      "loading": _vm.cancelLoading
    },
    on: {
      "click": _vm.cancelOrder
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('button.cancelOrder')) + "\n                            ")]) : _vm._e(), _vm._v(" "), ((_vm.isZNB || _vm.is220 || _vm.isZRE) && _vm.canCancelEdiOrder) ? _c('el-button', {
    staticClass: "small danger margin-b-10",
    attrs: {
      "loading": _vm.cancelLoading
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('button.cancelEDIOrder')) + "\n                            ")]) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 16
    }
  }, [_c('div', {
    staticClass: "order-actions-bar"
  }, [((_vm.isZNB || _vm.is220) && (_vm.isEdiConfirmed || _vm.isEdiProcessed || _vm.isAskoAndBilled) || (_vm.currentOrder.orderType != 'EDI')) ? _c('div', {
    staticClass: "btn-group order-action-secondary"
  }, [_c('button', {
    staticClass: "btn info el-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showPrintableDeliveryNote
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('button.showPrintableDeliveryNote')))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.toggleDropdownDelivery
    }
  }, [_c('span', {
    staticClass: "sr-only"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    class: {
      show: _vm.dropdownStateDelivery
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.showPrintableDeliveryNote
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                                     " + _vm._s(_vm.$t('button.showPrintableDeliveryNote')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.downloadPrintableDeliveryNote
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                                     " + _vm._s(_vm.$t('button.downloadPrintableDeliveryNote')))])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-actions-primary"
  }, [(_vm.currentOrder.orderStatus == 'confirmed' && _vm.currentOrder.orderType !== 'EDI') ? _c('div', [_c('el-checkbox', {
    attrs: {
      "label": _vm.$t('static.orders.orderConfirm.orderConfirmNotification')
    },
    model: {
      value: (_vm.orderConfirmNotification),
      callback: function($$v) {
        _vm.orderConfirmNotification = $$v
      },
      expression: "orderConfirmNotification"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.canConfirmOrder) ? _c('el-button', {
    attrs: {
      "loading": _vm.currentOrder.orderType === 'EDI' && _vm.loadingConfirm,
      "disabled": _vm.hasUnconfirmedOrderProduct
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('button.confirm')) + "\n                                ")]) : _vm._e(), _vm._v(" "), ((_vm.currentOrder.orderStatus == 'confirmed' && !['EDI', 'Wordpress'].includes(_vm.currentOrder.orderType)) || (_vm.currentEdiOrder.ediOrderStatusName == 'confirmed' && _vm.currentOrder.orderType == 'EDI')) ? _c('el-button', {
    attrs: {
      "loading": _vm.loadingConfirm
    },
    on: {
      "click": _vm.showConfirmModalShipping
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('button.shippingConfirm')) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.canCreateInvoice && _vm.currentOrder.orderType == 'EDI') ? _c('el-button', {
    on: {
      "click": _vm.createBill
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('button.createInvoice')) + "\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.canCreateInvoice && _vm.currentOrder.orderType != 'EDI' && ['shipping_confirmed', 'picked', 'shipped', 'delivered'].includes(_vm.currentOrder.orderStatus)) ? _c('div', {
    staticClass: "btn-group invoice-action-group"
  }, [_c('button', {
    staticClass: "btn info el-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.createBill
    }
  }, [_vm._v(_vm._s(_vm.$t('button.createInvoice')))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.toggleDropdownInvoice
    }
  }, [_c('span', {
    staticClass: "sr-only"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    class: {
      show: _vm.dropdownStateInvoice
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.createBill
    }
  }, [_vm._v(_vm._s(_vm.$t('button.createInvoice')))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    },
    on: {
      "click": _vm.invoiceExternal
    }
  }, [_vm._v(_vm._s(_vm.$t('button.invoiceExternally')))])])], 1) : _vm._e(), _vm._v(" "), (_vm.canConfirmAsOrdered) ? _c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn info el-button",
    attrs: {
      "disabled": _vm.hasUnconfirmedOrderProduct,
      "type": "button"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.$t('button.confirm')))]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-danger dropdown-toggle dropdown-toggle-split",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    },
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('span', {
    staticClass: "sr-only"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    class: {
      show: _vm.dropdownState
    },
    on: {
      "click": _vm.confirmAsOrdered
    }
  }, [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "role": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('button.confirmAsOrder')))])])], 1) : _vm._e()], 1)])]), _vm._v(" "), (_vm.currentOrder.orderStatus == 'invoiced_externally' && _vm.currentOrder.orderType != 'EDI') ? _c('el-col', {
    attrs: {
      "md": 8
    }
  }, [_c('el-button', {
    staticClass: "small margin-b-10",
    on: {
      "click": _vm.createReturnOrder
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('button.createReturnOrder')) + "\n                            ")])], 1) : _vm._e()], 1)], 1)])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "blockmainWrapper",
    attrs: {
      "lg": 8
    }
  }, [_c('v-client-info', {
    attrs: {
      "currentEdiOrder": _vm.currentEdiOrder,
      "client": _vm.currentClient
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "orderproductWrapper margin-t-10",
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "order-lines-card"
  }, [_c('h3', {
    staticClass: "order-lines-title"
  }, [_vm._v(_vm._s(_vm.$t('static.orders.orderLines')))]), _vm._v(" "), _c('el-row', [(_vm.currentOrder.orderType) ? _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [(_vm.currentOrder.orderType === 'EDI') ? _c('v-edi-order-items-table', {
    attrs: {
      "order": _vm.currentOrder
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderType !== 'EDI') ? _c('v-products-table', {
    attrs: {
      "order": _vm.currentOrder
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)])], 1)], 1), _vm._v(" "), (!_vm.isCancelled && _vm.currentOrder.orderType == 'EDI' && this.currentEdiOrder.standard === 'stand') ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.orders.formTabs.deliveryNote'),
      "name": "2"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 35
    }
  }, [(_vm.unassignedProducts.length > 0) ? _c('el-col', {
    attrs: {
      "lg": 14
    }
  }, [_c('el-card', {
    staticClass: "box-card unassigned-products-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.orders.package.UnassignedProductCardTitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.unassignedProducts,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('static.orders.package.unassignedTable.name'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gtin",
      "label": _vm.$t('static.orders.package.unassignedTable.gtin'),
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantityConfirmed",
      "label": _vm.$t('static.orders.package.unassignedTable.quantityConfirmed')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantityPacked",
      "label": _vm.$t('static.orders.package.unassignedTable.quantityPacked')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quantityUnpacked",
      "label": _vm.$t('static.orders.package.unassignedTable.quantityUnpacked')
    }
  })], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.currentOrder.orderType) ? _c('el-col', {
    attrs: {
      "lg": 10
    }
  }, [_c('el-card', {
    staticClass: "box-card new-package-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('static.orders.package.newPackageCardTitle')))])]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [_c('v-form', {
    attrs: {
      "form": _vm.packageForm,
      "translation": "form.addEditPackage",
      "hasLabel": true
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "loading": _vm.packageForm.loading,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.createPackage()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save')))]), _vm._v(" "), _c('v-message', {
    attrs: {
      "success": _vm.successMessage
    }
  })], 1)]), _vm._v(" "), _c('h2')], 1) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 35
    }
  }, [(_vm.currentOrder.orderType) ? _c('el-col', {
    attrs: {
      "lg": 24
    }
  }, [_c('div', {
    staticClass: "flex items-center",
    staticStyle: {
      "justify-content": "space-between"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('static.orders.edit.packageTitle')))]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-end"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select"
    },
    model: {
      value: (_vm.selectedPaperSize),
      callback: function($$v) {
        _vm.selectedPaperSize = $$v
      },
      expression: "selectedPaperSize"
    }
  }, _vm._l((_vm.paperSizes), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "margin": "3px 5px"
    },
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.downloadShippingLabel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" " + _vm._s(_vm.$t('static.orders.package.downloadAllShippingLabel')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    staticStyle: {
      "margin": "3px 5px"
    },
    attrs: {
      "type": "text",
      "size": "small"
    },
    on: {
      "click": _vm.downloadPalletLabel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" " + _vm._s(_vm.$t('static.orders.package.downloadProductMixLabel')))])], 1)]), _vm._v(" "), _c('v-manage-package', {
    attrs: {
      "order": _vm.currentOrder,
      "packages": _vm.packages
    }
  })], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isCancelled && !_vm.isAppointmentCompleted && !['Wordpress'].includes(_vm.currentOrder.orderType) && !_vm.currentOrder.sent) ? _c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.orders.formTabs.edit'),
      "name": "3"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.orders",
      "hasLabel": true
    }
  }), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.store
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save')))]), _vm._v(" "), _c('v-message', {
    attrs: {
      "success": _vm.successMessage
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c945caa","hasScoped":false}!./src/app/pages/withNavigation/orders/edit/edit.html
// module id = 2930
// module chunks = 1